export interface CpLine {
  id: string;
  name: string;
  pairing: string;
  tag: string;
  heat: number;
  summary: string;
  stages: { stage: string; desc: string }[];
  cover: string;
}

export const cpLines: CpLine[] = [
  {
    id: "cp-01",
    name: "「沉舟」线",
    pairing: "陆沉渊 × 顾长风",
    tag: "暗线纠葛 · 高人气",
    heat: 95,
    summary: "正与魔、兄与敌，一场跨越正邪的纠葛。每一次相遇都是冰与火的碰撞，也是读者票选热度最高的 CP 线。",
    stages: [
      { stage: "初遇结怨", desc: "旧日恩怨在一场意外中埋下种子，二人的第一面便注定剑拔弩张。" },
      { stage: "并肩于险", desc: "被迫合作对抗更大的危机，短暂的同路让敌意出现了裂缝。" },
      { stage: "锋芒交错", desc: "立场再次对立，却都在动手时默契地留了三分余地，暗线愈发扑朔迷离。" },
      { stage: "迷雾将散", desc: "身世与旧案的真相逐渐浮出水面，二人纠葛的走向牵动全站讨论。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Two%20rival%20cultivators%20standing%20back%20to%20back%20in%20Chinese%20ink%20wash%20xianxia%20illustration%2C%20one%20in%20grey%20hanfu%20one%20in%20black%20and%20crimson%2C%20lightning%20and%20mist%20between%20them%2C%20dramatic%20warm%20and%20cool%20contrast%2C%20refined%20detail&width=1200&height=700&seq=cp-chenzhou-01&orientation=landscape",
  },
  {
    id: "cp-02",
    name: "「挽月照沉」线",
    pairing: "苏挽月 × 陆沉渊",
    tag: "师姐互动 · 默契搭档",
    heat: 88,
    summary: "大师姐与大师兄，嘴上针锋相对、危难时却能托付后背。欢喜冤家式的默契互动收割了大批路人粉。",
    stages: [
      { stage: "互看不顺", desc: "一个嫌榆木，一个嫌暴躁，日常拌嘴成为云隐峰保留节目。" },
      { stage: "并肩作战", desc: "一次次任务里背靠背的默契，让彼此在对方眼里悄悄不同。" },
      { stage: "患难见情", desc: "生死关头的毫不犹豫，将那份别扭的心意摆到了明面。" },
      { stage: "并肩而行", desc: "褪去口是心非，二人开始学着把关怀说出口，甜度持续上升。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Martial%20partners%20senior%20brother%20and%20senior%20sister%20flying%20on%20swords%20side%20by%20side%20in%20Chinese%20ink%20wash%20illustration%2C%20playful%20bickering%20yet%20trusting%2C%20warm%20vermilion%20and%20gold%20tones%2C%20misty%20peaks%2C%20refined%20detail&width=1200&height=700&seq=cp-wanyue-01&orientation=landscape",
  },
  {
    id: "cp-03",
    name: "「如沐春阳」线",
    pairing: "陆沉渊 × 温如初",
    tag: "师兄关系 · 温馨日常",
    heat: 82,
    summary: "大师兄与小师弟的温馨日常线，一个护得不动声色，一个黏得理所当然，是全站治愈担当。",
    stages: [
      { stage: "初入门", desc: "呆萌小师弟初入云隐峰，被大师兄「照顾」得明明白白。" },
      { stage: "日常相处", desc: "罚抄、投喂、偷跑下山被抓……师门日常里全是软乎乎的温情。" },
      { stage: "暗处守护", desc: "大师兄一次次不动声色的挡劫，让这份兄弟情谊愈发戳心。" },
      { stage: "互相奔赴", desc: "小师弟也开始学着反过来护住大师兄，双向奔赴的暖意封神。" },
    ],
    cover:
      "https://readdy.ai/api/search-image?query=Warmhearted%20senior%20brother%20and%20innocent%20junior%20disciple%20walking%20through%20a%20moonlit%20sect%20courtyard%20in%20Chinese%20ink%20wash%20illustration%2C%20lanterns%20glowing%20warm%20gold%2C%20tender%20protective%20atmosphere%2C%20refined%20detail&width=1200&height=700&seq=cp-wenchun-01&orientation=landscape",
  },
];